import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { RegionId } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches patients with their owner data.
 * Archived patients are excluded by default; pass `includeArchived: true` to include them.
 * Pass `region` to scope to a region (by owner) — callers that omit it list
 * across all regions.
 */
export function useListPatients(opts?: {
  q?: string
  limit?: number
  offset?: number
  includeArchived?: boolean
  region?: RegionId
  enabled?: boolean
}) {
  const api = useOsApi()
  const { q, limit, offset, includeArchived, region, enabled } = opts ?? {}

  return useQuery({
    queryKey: ['patients', { q, limit, offset, includeArchived, region }],
    enabled,
    queryFn: async () => {
      const response = await api.get('/patients', {
        query: { q, limit, offset, includeArchived, region },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    placeholderData: keepPreviousData,
  })
}
